import ApiError from 'src/api/ApiError';

type ValidError = ApiError | Error | string;

interface AuthErrorMessageProps {
  error?: ValidError | null;
  className?: string;
}

export function AuthErrorMessage({
  error,
  className = '',
}: AuthErrorMessageProps) {
  if (!error) {
    return null;
  }

  const message = typeof error === 'string' ? error : error.message;
  const displayMessage = message?.trim() || 'An unexpected error occurred';

  return (
    <p className={`text-red-600 text-sm text-center ${className}`}>
      {displayMessage}
    </p>
  );
}
